import React from "react";
import CustomAlert from "../CustomComponents/CustomAlert/CustomAlert";
import {
  CustomCloseIcon,
} from "../CustomComponents/CustomIcon/CustomIcon";
import { useStyles } from "../../assets/jss/ErrorAlert";
import { useTranslation } from "react-i18next";
import errorToast from "../../assets/images/errorToast.png";

const ErrorAlertTC = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { message, isOpen, description, alertType } = props;
  const [messageText, setMessageText] = React.useState(message);
  const [isOpenAlert, setIsOpenAlert] = React.useState(isOpen);
  const [alertDescription, setAlertDescription] = React.useState(description);
  const [type, setType] = React.useState(alertType);
  const [alertHideDuration] = React.useState(3000);


  React.useEffect(() => {
    setMessageText(message);
    setIsOpenAlert(isOpen);
    setAlertDescription(description);
    setType(alertType);
  }, [isOpen]);

  const onClose = () => {
    setMessageText("");
    setIsOpenAlert(false);
    if (props.isClose) {
      props.isClose(true);
    }
  };

  return (
    <CustomAlert
      className={classes.errorAlert}
      open={isOpenAlert}
      icon={<img src={errorToast} />}
      autoHideDuration={alertHideDuration}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      alertseverity={type ? type : "error"}
      onClose={() => onClose()}
    >
      <div className={classes.alertWrap}>
        <div className={classes.message}>
          {messageText}
          <br />
          {alertDescription ? (
            <div
              className={classes.description}
              dangerouslySetInnerHTML={{ __html: alertDescription }}
            ></div>
          ) : null}
        </div>
        <div className={classes.action}>
          <span className={classes.actionClose} onClick={onClose}>
            <CustomCloseIcon fontSize="large" />
          </span>
        </div>
      </div>
    </CustomAlert>
  );
};

export default ErrorAlertTC;
